import { GlobalIndicatorsDatasetKey } from "@/model/enum/globalIndicators/globalIndicatorsDatasetKey"

/**
 * Interface for GlobalIndicators filters
 */
export interface GlobalIndicatorsFilter {
  year?: number | null
  region?: string | null
  country?: string | null
  countries?: string | null
  dutyStation?: string | null
}

/**
 * Service to manage filters for GlobalIndicators
 */
export default class GlobalIndicatorsFilterService {
  /**
   * Normalize filters for API request
   * @param filter The filter object containing filter criteria
   * @returns Normalized filter object
   */
  static normalizeFilters(filter: GlobalIndicatorsFilter): GlobalIndicatorsFilter {
    const normalizedFilter: GlobalIndicatorsFilter = {}

    if (filter.year !== undefined && filter.year !== null) {
      normalizedFilter.year = filter.year
    }

    if (filter.region !== undefined && filter.region !== null) {
      normalizedFilter.region = filter.region
    }

    if (filter.country !== undefined && filter.country !== null) {
      normalizedFilter.countries = filter.country
    }

    if (filter.dutyStation !== undefined && filter.dutyStation !== null) {
      normalizedFilter.dutyStation = filter.dutyStation
    }

    return normalizedFilter
  }

  /**
   * Convert filters to URL parameters
   * @param filter The filter object containing filter criteria
   * @returns Array of URL parameter strings
   */
  static toUrlParams(filter: GlobalIndicatorsFilter): string[] {
    const params: string[] = []

    if (filter.year !== undefined && filter.year !== null) {
      params.push("year=" + filter.year)
    }

    if (filter.region !== undefined && filter.region !== null) {
      params.push("region=" + filter.region)
    }

    if (filter.country !== undefined && filter.country !== null) {
      params.push("countries=" + filter.country)
    }

    if (filter.dutyStation !== undefined && filter.dutyStation !== null) {
      params.push("dutyStation=" + filter.dutyStation)
    }

    return params
  }

  /**
   * Build URL with filters
   * @param baseUrl The base URL
   * @param filter The filter object containing filter criteria
   * @returns URL with filter parameters
   */
  static buildUrl(baseUrl: string, filter: GlobalIndicatorsFilter): string {
    const params = this.toUrlParams(filter)
    return baseUrl + (params.length ? "?" + params.join("&") : "")
  }
}
